import { createTypes } from '../../utils';

const types = createTypes('tracking', [
    'SAVE_TRACKING_DATA',
    'SAVE_IMPRESSION_DATA',
    'CLEAR_IMPRESSION_DATA'
]);

export default types;
